import * as Yup from 'yup';

export default () =>
  Yup.object().shape({
    feeInPence: Yup.number().typeError('Type only numbers'),
  });
